import { render, staticRenderFns } from "./view_program_schemes.vue?vue&type=template&id=cf89c652&scoped=true"
import script from "./view_program_schemes.vue?vue&type=script&lang=js"
export * from "./view_program_schemes.vue?vue&type=script&lang=js"
import style0 from "./view_program_schemes.vue?vue&type=style&index=0&id=cf89c652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf89c652",
  null
  
)

export default component.exports